"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var ValidatedForm_1 = tslib_1.__importDefault(require("uniforms/ValidatedForm"));

var BaseForm_1 = tslib_1.__importDefault(require("./BaseForm"));

var Validated = function Validated(parent) {
  var _a;

  return _a =
  /** @class */
  function (_super) {
    tslib_1.__extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return class_1;
  }(ValidatedForm_1["default"].Validated(parent)), _a.Validated = Validated, _a;
};

exports["default"] = Validated(BaseForm_1["default"]);